class ImageTextColumns extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    if (window.outerWidth >= 768) {
      this.updateEl()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    if (window.outerWidth >= 768) {
      window.addEventListener('scroll', this.onScroll, { passive: true })
    }
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    const containerOffsetTop = window.BAO.utils.getOffsetTop(this)
    const elementStartPoint = containerOffsetTop - window.innerHeight
    const elementEndPoint = containerOffsetTop + this.offsetHeight

    const start = -150
    const amountToMove = 300
    const end = start + amountToMove

    const columns = this.els.column.elements

    if (this.lastKnownY <= elementStartPoint) {
      columns.forEach((column, index) => {
        column.style.transform = `translateY(${
          index === 0 ? start : start * -1
        }px)`
      })
      return
    }

    if (this.lastKnownY > elementEndPoint) {
      columns.forEach((column, index) => {
        column.style.transform = `translateY(${index === 0 ? end : end * -1}px)`
      })

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const moveAmount = start + amountToMove * scrollYAsAPercentageOfJourney

    columns.forEach((column, index) => {
      column.style.transform = `translateY(${
        index === 0 ? moveAmount : moveAmount * -1
      }px)`
    })
  }
}

customElements.define('image-text-columns', ImageTextColumns)
